var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/image/createImagePlugin.ts
import { createPluginFactory } from "@udecode/plate-common";

// src/image/transforms/insertImage.ts
import {
  getPluginType,
  insertNodes
} from "@udecode/plate-common";
var insertImage = (editor, url, options = {}) => {
  const text = { text: "" };
  const image = {
    type: getPluginType(editor, ELEMENT_IMAGE),
    url,
    children: [text]
  };
  insertNodes(editor, image, __spreadValues({
    nextBlock: true
  }, options));
};

// src/image/utils/isImageUrl.ts
import { isUrl } from "@udecode/plate-common";
var imageExtensions = /* @__PURE__ */ new Set([
  "ase",
  "art",
  "bmp",
  "blp",
  "cd5",
  "cit",
  "cpt",
  "cr2",
  "cut",
  "dds",
  "dib",
  "djvu",
  "egt",
  "exif",
  "gif",
  "gpl",
  "grf",
  "icns",
  "ico",
  "iff",
  "jng",
  "jpeg",
  "jpg",
  "jfif",
  "jp2",
  "jps",
  "lbm",
  "max",
  "miff",
  "mng",
  "msp",
  "nitf",
  "ota",
  "pbm",
  "pc1",
  "pc2",
  "pc3",
  "pcf",
  "pcx",
  "pdn",
  "pgm",
  "PI1",
  "PI2",
  "PI3",
  "pict",
  "pct",
  "pnm",
  "pns",
  "ppm",
  "psb",
  "psd",
  "pdd",
  "psp",
  "px",
  "pxm",
  "pxr",
  "qfx",
  "raw",
  "rle",
  "sct",
  "sgi",
  "rgb",
  "int",
  "bw",
  "tga",
  "tiff",
  "tif",
  "vtf",
  "xbm",
  "xcf",
  "xpm",
  "3dv",
  "amf",
  "ai",
  "awg",
  "cgm",
  "cdr",
  "cmx",
  "dxf",
  "e2d",
  "egt",
  "eps",
  "fs",
  "gbr",
  "odg",
  "svg",
  "stl",
  "vrml",
  "x3d",
  "sxd",
  "v2d",
  "vnd",
  "wmf",
  "emf",
  "art",
  "xar",
  "png",
  "webp",
  "jxr",
  "hdp",
  "wdp",
  "cur",
  "ecw",
  "iff",
  "lbm",
  "liff",
  "nrrd",
  "pam",
  "pcx",
  "pgf",
  "sgi",
  "rgb",
  "rgba",
  "bw",
  "int",
  "inta",
  "sid",
  "ras",
  "sun",
  "tga"
]);
var isImageUrl = (url) => {
  if (!isUrl(url))
    return false;
  const ext = new URL(url).pathname.split(".").pop();
  return imageExtensions.has(ext);
};

// src/image/withImageEmbed.ts
var withImageEmbed = (editor, plugin) => {
  const { insertData } = editor;
  editor.insertData = (dataTransfer) => {
    const text = dataTransfer.getData("text/plain");
    if (isImageUrl(text)) {
      insertImage(editor, text);
      return;
    }
    insertData(dataTransfer);
  };
  return editor;
};

// src/image/withImageUpload.ts
import {
  getInjectedPlugins,
  pipeInsertDataQuery
} from "@udecode/plate-common";
var withImageUpload = (editor, plugin) => {
  const {
    options: { uploadImage }
  } = plugin;
  const { insertData } = editor;
  editor.insertData = (dataTransfer) => {
    const text = dataTransfer.getData("text/plain");
    const { files } = dataTransfer;
    if (!text && files && files.length > 0) {
      const injectedPlugins = getInjectedPlugins(editor, plugin);
      if (!pipeInsertDataQuery(injectedPlugins, {
        data: text,
        dataTransfer
      })) {
        return insertData(dataTransfer);
      }
      for (const file of files) {
        const reader = new FileReader();
        const [mime] = file.type.split("/");
        if (mime === "image") {
          reader.addEventListener("load", async () => {
            if (!reader.result) {
              return;
            }
            const uploadedUrl = uploadImage ? await uploadImage(reader.result) : reader.result;
            insertImage(editor, uploadedUrl);
          });
          reader.readAsDataURL(file);
        }
      }
    } else {
      insertData(dataTransfer);
    }
  };
  return editor;
};

// src/image/withImage.ts
var withImage = (editor, plugin) => {
  const {
    options: { disableUploadInsert, disableEmbedInsert }
  } = plugin;
  if (!disableUploadInsert) {
    editor = withImageUpload(editor, plugin);
  }
  if (!disableEmbedInsert) {
    editor = withImageEmbed(editor, plugin);
  }
  return editor;
};

// src/image/createImagePlugin.ts
var ELEMENT_IMAGE = "img";
var createImagePlugin = createPluginFactory({
  key: ELEMENT_IMAGE,
  isElement: true,
  isVoid: true,
  withOverrides: withImage,
  then: (editor, { type }) => ({
    deserializeHtml: {
      rules: [
        {
          validNodeName: "IMG"
        }
      ],
      getNode: (el) => ({
        type,
        url: el.getAttribute("src")
      })
    }
  })
});

// src/image/components/Image.tsx
import { createPrimitiveComponent, useElement } from "@udecode/plate-common";
var useImage = () => {
  const { url } = useElement();
  return {
    props: {
      src: url,
      draggable: true
    }
  };
};
var Image = createPrimitiveComponent("img")({
  propsHook: useImage
});

// src/media/insertMedia.ts
import {
  getPluginType as getPluginType2
} from "@udecode/plate-common";
var insertMedia = async (editor, _a = {}) => {
  var _b = _a, {
    getUrl,
    type = getPluginType2(editor, ELEMENT_IMAGE)
  } = _b, options = __objRest(_b, [
    "getUrl",
    "type"
  ]);
  const url = getUrl ? await getUrl() : window.prompt(
    `Enter the URL of the ${type === ELEMENT_IMAGE ? ELEMENT_IMAGE : ELEMENT_MEDIA_EMBED}`
  );
  if (!url)
    return;
  if (type === getPluginType2(editor, ELEMENT_IMAGE)) {
    insertImage(editor, url, options);
  } else {
    insertMediaEmbed(editor, { url }, options);
  }
};

// src/media/types.ts
var ELEMENT_MEDIA = "media";

// src/media/useMediaState.ts
import React from "react";
import { useElement as useElement2 } from "@udecode/plate-common";
import { useFocused, useReadOnly, useSelected } from "slate-react";

// src/media-embed/createMediaEmbedPlugin.ts
import { createPluginFactory as createPluginFactory2 } from "@udecode/plate-common";

// src/media-embed/parseIframeUrl.ts
var parseIframeUrl = (url) => {
  var _a, _b;
  if (url.slice(0, 4) !== "http") {
    const regexMatchSrc = /src=".*?"/;
    const regexGroupQuotes = /"([^"]*)"/;
    const src = (_a = url.match(regexMatchSrc)) == null ? void 0 : _a[0];
    const returnString = (_b = src == null ? void 0 : src.match(regexGroupQuotes)) == null ? void 0 : _b[1];
    if (returnString) {
      url = returnString;
    }
  }
  return url;
};

// src/media-embed/createMediaEmbedPlugin.ts
var ELEMENT_MEDIA_EMBED = "media_embed";
var createMediaEmbedPlugin = createPluginFactory2({
  key: ELEMENT_MEDIA_EMBED,
  isElement: true,
  isVoid: true,
  options: {
    transformUrl: parseIframeUrl
  },
  then: (editor, { type }) => ({
    deserializeHtml: {
      rules: [
        {
          validNodeName: "IFRAME"
        }
      ],
      getNode: (el) => {
        const url = el.getAttribute("src");
        if (url) {
          return {
            type,
            url
          };
        }
      }
    }
  })
});

// src/media-embed/parseTwitterUrl.ts
var twitterRegex = new RegExp("^https?:\\/\\/twitter\\.com\\/(?:#!\\/)?(\\w+)\\/status(es)?\\/(?<id>\\d+)");
var parseTwitterUrl = (url) => {
  var _a, _b;
  if (url.match(twitterRegex)) {
    return {
      provider: "twitter",
      id: (_b = (_a = twitterRegex.exec(url)) == null ? void 0 : _a.groups) == null ? void 0 : _b.id,
      url
    };
  }
};

// src/media-embed/parseVideoUrl.ts
import { isUrl as isUrl2 } from "@udecode/plate-common";
import videoParser from "js-video-url-parser";
var YOUTUBE_PREFIX = "https://www.youtube.com/embed/";
var VIMEO_PREFIX = "https://player.vimeo.com/video/";
var DAILYMOTION_PREFIX = "https://www.dailymotion.com/embed/video/";
var YOUKU_PREFIX = "https://player.youku.com/embed/";
var COUB_PREFIX = "https://coub.com/embed/";
var VIDEO_PROVIDERS = [
  "youtube",
  "vimeo",
  "dailymotion",
  "youku",
  "coub"
];
var parseVideoUrl = (url) => {
  if (!isUrl2(url))
    return;
  const videoData = videoParser.parse(url);
  if ((videoData == null ? void 0 : videoData.provider) && videoData.id) {
    const { id, provider } = videoData;
    const providerUrls = {
      youtube: `${YOUTUBE_PREFIX}${id}`,
      vimeo: `${VIMEO_PREFIX}${id}`,
      dailymotion: `${DAILYMOTION_PREFIX}${id}`,
      youku: `${YOUKU_PREFIX}${id}`,
      coub: `${COUB_PREFIX}${id}`
    };
    return {
      id,
      provider,
      url: providerUrls[provider]
    };
  }
};

// src/media-embed/transforms/insertMediaEmbed.ts
import {
  getParentNode,
  insertNodes as insertNodes2
} from "@udecode/plate-common";
var insertMediaEmbed = (editor, {
  url = "",
  key = ELEMENT_MEDIA_EMBED
}, options = {}) => {
  if (!editor.selection)
    return;
  const selectionParentEntry = getParentNode(editor, editor.selection);
  if (!selectionParentEntry)
    return;
  const [, path] = selectionParentEntry;
  insertNodes2(
    editor,
    {
      type: key,
      url,
      children: [{ text: "" }]
    },
    __spreadValues({
      at: path,
      nextBlock: true
    }, options)
  );
};

// src/media/useMediaState.ts
var useMediaState = ({
  urlParsers
} = {}) => {
  const element = useElement2();
  const focused = useFocused();
  const selected = useSelected();
  const readOnly = useReadOnly();
  const { url, align } = element;
  const embed = React.useMemo(() => {
    if (!urlParsers)
      return;
    for (const parser of urlParsers) {
      const data = parser(url);
      if (data) {
        return data;
      }
    }
  }, [urlParsers, url]);
  const isTweet = (embed == null ? void 0 : embed.provider) === "twitter";
  const isVideo = !!(embed == null ? void 0 : embed.provider) && VIDEO_PROVIDERS.includes(embed.provider);
  const isYoutube = (embed == null ? void 0 : embed.provider) === "youtube";
  return {
    align,
    focused,
    selected,
    readOnly,
    embed,
    isTweet,
    isVideo,
    isYoutube
  };
};

// src/media/useMediaToolbarButton.ts
import { useEditorRef } from "@udecode/plate-common";
var useMediaToolbarButton = ({
  nodeType
} = {}) => {
  const editor = useEditorRef();
  return {
    props: {
      onMouseDown: (e) => {
        e.preventDefault();
      },
      onClick: async () => {
        await insertMedia(editor, { type: nodeType });
      }
    }
  };
};

// src/media/FloatingMedia/FloatingMediaEditButton.tsx
import React2 from "react";
import { createPrimitiveComponent as createPrimitiveComponent2, useElement as useElement3 } from "@udecode/plate-common";

// src/media/FloatingMedia/floatingMediaStore.ts
import { createZustandStore } from "@udecode/plate-common";
var floatingMediaStore = createZustandStore("floatingMedia")({
  url: "",
  isEditing: false
}).extendActions((set) => ({
  reset: () => {
    set.url("");
    set.isEditing(false);
  }
}));
var floatingMediaActions = floatingMediaStore.set;
var floatingMediaSelectors = floatingMediaStore.get;
var useFloatingMediaSelectors = () => floatingMediaStore.use;

// src/media/FloatingMedia/FloatingMediaEditButton.tsx
var useFloatingMediaEditButton = () => {
  const element = useElement3();
  return {
    props: {
      onClick: React2.useCallback(() => {
        floatingMediaActions.url(element.url);
        floatingMediaActions.isEditing(true);
      }, [element.url])
    }
  };
};
var FloatingMediaEditButton = createPrimitiveComponent2("button")({
  propsHook: useFloatingMediaEditButton
});

// src/media/FloatingMedia/FloatingMediaUrlInput.tsx
import React3 from "react";
import {
  createPrimitiveComponent as createPrimitiveComponent3,
  focusEditor as focusEditor2,
  useEditorRef as useEditorRef2,
  useElement as useElement4,
  useHotkeys
} from "@udecode/plate-common";

// src/media/FloatingMedia/submitFloatingMedia.ts
import {
  focusEditor,
  getPluginOptions,
  isUrl as isUrl3,
  setNodes
} from "@udecode/plate-common";
var submitFloatingMedia = (editor, {
  element,
  pluginKey = ELEMENT_MEDIA
}) => {
  let url = floatingMediaSelectors.url();
  if (url === element.url) {
    floatingMediaActions.reset();
    return true;
  }
  const { isUrl: _isUrl = isUrl3, transformUrl } = getPluginOptions(editor, pluginKey);
  const isValid = _isUrl(url);
  if (!isValid)
    return;
  if (transformUrl) {
    url = transformUrl(url);
  }
  setNodes(editor, {
    url
  });
  floatingMediaActions.reset();
  focusEditor(editor, editor.selection);
  return true;
};

// src/media/FloatingMedia/FloatingMediaUrlInput.tsx
var useFloatingMediaUrlInputState = ({
  pluginKey
} = {}) => {
  const editor = useEditorRef2();
  const element = useElement4();
  useHotkeys(
    "enter",
    (e) => {
      if (submitFloatingMedia(editor, { element, pluginKey })) {
        e.preventDefault();
      }
    },
    {
      enableOnFormTags: ["INPUT"]
    },
    []
  );
  useHotkeys(
    "escape",
    () => {
      if (floatingMediaSelectors.isEditing()) {
        floatingMediaActions.reset();
        focusEditor2(editor, editor.selection);
      }
    },
    {
      enableOnFormTags: ["INPUT"],
      enableOnContentEditable: true
    },
    []
  );
  return {
    defaultValue: floatingMediaSelectors.url()
  };
};
var useFloatingMediaUrlInput = ({
  defaultValue
}) => {
  const onChange = React3.useCallback((e) => {
    floatingMediaActions.url(e.target.value);
  }, []);
  return {
    props: {
      onChange,
      autoFocus: true,
      defaultValue
    }
  };
};
var FloatingMediaUrlInput = createPrimitiveComponent3("input")({
  stateHook: useFloatingMediaUrlInputState,
  propsHook: useFloatingMediaUrlInput
});

// src/media/FloatingMedia/FloatingMedia.tsx
var FloatingMedia = {
  EditButton: FloatingMediaEditButton,
  UrlInput: FloatingMediaUrlInput
};
export {
  ELEMENT_IMAGE,
  ELEMENT_MEDIA,
  ELEMENT_MEDIA_EMBED,
  FloatingMedia,
  FloatingMediaEditButton,
  FloatingMediaUrlInput,
  Image,
  VIDEO_PROVIDERS,
  createImagePlugin,
  createMediaEmbedPlugin,
  floatingMediaActions,
  floatingMediaSelectors,
  floatingMediaStore,
  insertImage,
  insertMedia,
  insertMediaEmbed,
  isImageUrl,
  parseIframeUrl,
  parseTwitterUrl,
  parseVideoUrl,
  submitFloatingMedia,
  useFloatingMediaEditButton,
  useFloatingMediaSelectors,
  useFloatingMediaUrlInput,
  useFloatingMediaUrlInputState,
  useImage,
  useMediaState,
  useMediaToolbarButton,
  withImage,
  withImageEmbed,
  withImageUpload
};
//# sourceMappingURL=index.mjs.map